import { configure, defineRule } from 'vee-validate';
import { required, email, min, max, min_value, max_value, confirmed } from '@vee-validate/rules';
import { localize } from '@vee-validate/i18n';

// Define the rules you want to use
defineRule('required', required);
defineRule('email', email);
defineRule('min', min);
defineRule('max', max);
defineRule('min_value', min_value);
defineRule('max_value', max_value);
defineRule('confirmed', confirmed);

// Configure Vee-Validate
configure({
  generateMessage: localize('en', {
    messages: {
      required: 'This field is required',
      email: 'Please enter a valid email address',
      min: 'This field must be at least {length} characters',
      max: 'This field must not exceed {length} characters',
      min_value: 'This field must be at least {min}',
      max_value: 'This field must not exceed {max}',
      confirmed: 'The passwords do not match'
    }
  }),
  validateOnInput: true // Enable validation on input
}); 